import { CircleSpinnerInline } from '@newfront-insurance/core-ui';
import { cn } from '@newfront-insurance/core-ui/v2';

interface ProgressMessageProps {
  message: string;
}

export function ProgressMessage({ message }: ProgressMessageProps) {
  return (
    <div className="group/message mx-auto w-full max-w-[800px] px-8">
      <div className={cn('relative inline-flex w-auto items-center gap-3 rounded-lg', 'overflow-hidden')}>
        <div className="animate-shimmer pointer-events-none absolute inset-0 z-10 bg-gradient-to-r from-transparent via-white to-transparent opacity-30" />
        <CircleSpinnerInline size={16} />
        <span className="text-steel-400 relative z-0 text-sm font-semibold">{message}</span>
      </div>
    </div>
  );
}
